module.exports = [
	"None",
	"TrueOnly",
	"FalseOnly"
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/static/booleanRestrictions.json
// module id = 347
// module chunks = 0